/**
 * Exhaly — Blog article behaviour (no dependencies, ~3 KB).
 *
 * - Builds the "In this guide" table of contents from the H2s in the body
 *   (hidden when there are fewer than the configured minimum).
 * - Wraps wide tables so they scroll sideways on phones.
 * - Moves the mobile product card after the 3rd H2 (falls back to end of body).
 * - Shows the sticky bottom bar after a scroll-depth threshold; dismissal is
 *   remembered for the session only.
 */
(function () {
  if (window.__exhalyBlog) return;
  window.__exhalyBlog = true;

  var article = document.querySelector('[data-sb-article]');
  if (!article) return;

  var body = article.querySelector('[data-sb-body]');
  if (!body) return;

  var slugify = function (text) {
    return String(text)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80) || 'section';
  };

  /* ---------- Table of contents ---------- */
  var toc = article.querySelector('[data-sb-toc]');
  var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
  if (toc) {
    var min = parseInt(toc.getAttribute('data-sb-toc-min') || '3', 10);
    var list = toc.querySelector('ol');
    if (headings.length >= min && list) {
      var used = {};
      headings.forEach(function (h) {
        var id = h.id || slugify(h.textContent);
        var base = id;
        var n = 2;
        while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) {
          id = base + '-' + n++;
        }
        used[id] = true;
        h.id = id;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      if (headings.length >= 7) list.classList.add('is-long');
      toc.hidden = false;
    } else {
      toc.hidden = true;
    }
  }

  /* ---------- Tables scroll on small screens ---------- */
  Array.prototype.slice.call(body.querySelectorAll('table')).forEach(function (table) {
    if (table.parentElement && table.parentElement.classList.contains('sb-table-scroll')) return;
    var wrap = document.createElement('div');
    wrap.className = 'sb-table-scroll';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
    var check = function () {
      wrap.classList.toggle('has-overflow', wrap.scrollWidth > wrap.clientWidth + 4);
    };
    check();
    window.addEventListener('resize', check, { passive: true });
    wrap.addEventListener(
      'scroll',
      function () {
        if (wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 4) wrap.classList.remove('has-overflow');
        else wrap.classList.add('has-overflow');
      },
      { passive: true }
    );
  });

  /* ---------- Inline (mobile) product card placement ---------- */
  var inline = article.querySelector('[data-sb-inline-product]');
  if (inline) {
    var target = headings[2] || null; // after the 3rd H2 if there is one
    if (target) {
      // Insert just before the H2 that follows the 3rd section, i.e. before the 4th H2,
      // or at the end of the body when the 3rd section is the last one.
      var next = headings[3] || null;
      if (next) body.insertBefore(inline, next);
      else body.appendChild(inline);
    } else {
      body.appendChild(inline);
    }
    inline.hidden = false;
  }

  /* ---------- Sticky bottom bar ---------- */
  var bar = document.querySelector('[data-sb-bar]');
  if (bar) {
    var key = 'sb-bar-dismissed';
    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(key) === '1';
    } catch (e) {
      /* storage unavailable: just show it */
    }
    if (!dismissed) {
      var threshold = parseFloat(bar.getAttribute('data-sb-bar-threshold') || '0.3');
      var shown = false;
      var show = function () {
        if (shown) return;
        shown = true;
        bar.classList.add('is-visible');
        document.body.classList.add('sb-bar-open');
        window.removeEventListener('scroll', onScroll);
      };
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if (window.scrollY / max >= threshold) show();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      var close = bar.querySelector('[data-sb-bar-close]');
      if (close) {
        close.addEventListener('click', function () {
          bar.classList.remove('is-visible');
          document.body.classList.remove('sb-bar-open');
          try {
            sessionStorage.setItem(key, '1');
          } catch (e) {
            /* ignore */
          }
        });
      }
    }
  }
})();
